import { useAuthorizedQuery } from "../api/authorized-query";
import { seedgreenAPI } from "../api/axios";
import { CoolerDTO } from "../dtos/CoolerDTO";
import { STALE_TIME_LONG } from "../queries/query.constants";
import { useQuery } from "@tanstack/vue-query";
const COOLER_STALE_TIME = STALE_TIME_LONG;
export function useCoolers() {
    const query = useQuery({
        enabled: useAuthorizedQuery(),
        queryKey: ["cooler"],
        queryFn: async () => (await seedgreenAPI.get("/v2/Cooler")).data,
        staleTime: COOLER_STALE_TIME,
        select: (data) => {
            try {
                return (data?.map((cooler) => new CoolerDTO(cooler)) ??
                    []);
            }
            catch (error) {
                console.error("query/cooler::select ERROR", error);
            }
        },
    });
    return {
        coolers: query.data,
        ...query,
    };
}
